import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute component that checks permissions before rendering content
 * @param {Object} props - Component props
 * @param {React.Component} props.children - Component to render if authorized
 * @param {boolean} props.canAccess - Whether user has access
 * @param {string} props.redirectTo - Where to redirect if unauthorized (default: '/profile')
 * @param {React.Component} props.fallback - Optional fallback component to show instead of redirecting
 * @returns {React.Component} - Protected content or redirect/fallback
 */
const ProtectedRoute = ({ 
  children, 
  canAccess, 
  redirectTo = '/profile', 
  fallback = null 
}) => {
  if (!canAccess) {
    if (fallback) {
      return fallback;
    }
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default ProtectedRoute; 